import * as React from "react";
import {CSSProperties} from "react";
import {Item} from "./Item";

import './styles/style.css';


import {ReactUtilities} from "shared/utilities/react/ReactUtilities";
import { Spring } from "shared/core/animation/react-spring/renderprops";





export class Tabs extends React.Component<TabsProps, TabsState> {
    static defaultProps: Partial<TabsProps> = {
        disableScrollYOnAnimation:true,
        ContentHeight:'auto',
        OccupyAvailableSpace:false,
        className:'',
        TabToOpen:''//disabled by default because if you use animations the scroll is shown (which looks ugly)
    };
    public static Item:typeof Item=Item;
    public different:number;
    private ListContainer: HTMLUListElement;
    private Content:HTMLElement;
    private spring: any;
    private spring2:any;


    constructor(props: TabsProps) {
        super(props);
        let Items=React.Children.toArray(this.props.children) as any;
        let itemsData:ItemData[]=[];
        for(let item of Items) {
            if(item==null||item=='')
                continue;
            itemsData.push({
                Item: item,
                Container: null
            });
        }



        let selectedItem:ItemData=null;
        if(this.props.TabToOpen!='')
            selectedItem=itemsData.find(x=>x.Item.props.Id==this.props.TabToOpen);
        else {
            selectedItem = itemsData.length>0?itemsData[0]:null;
        }


        this.state = {
            Status:"resting",
            Items:itemsData,
            SelectedItem:selectedItem,
            NextItem:null
        };




    }

    componentWillReceiveProps(nextProps: Readonly<TabsProps>, nextContext: any): void {

        if((nextProps as any).children!=this.props.children)
        {
            let Items=React.Children.toArray((nextProps as any).children) as any;
            let itemsData:ItemData[]=[];
            for(let item of Items) {
                if(item==null||item=='')
                    continue;
                itemsData.push({
                    Item: item,
                    Container: null
                });
            }

            let selectedItem = itemsData.find(x => x.Item.props.Id == nextProps.TabToOpen);
            if(nextProps.TabToOpen!=this.props.TabToOpen) {
                if(this.spring!=null) {

                    this.spring.stop();
                }
                if(this.spring2!=null)
                    this.spring2.stop();
                this.setState({Items:itemsData, Status:"switching",NextItem:selectedItem},()=>{this.setState({Status:"showing"})})
            }else {
                if(this.spring!=null) {

                    this.spring.stop();
                }
                if(this.spring2!=null)
                    this.spring2.stop();
                this.setState({Items: itemsData, SelectedItem: selectedItem});
            }



        }
    }


    private OnRest() {

        if(this.state.Status=="showing") {
            this.setState({NextItem: null, Status: 'resting', SelectedItem: this.state.NextItem});
        }
    }

    public render() {
        let beforeStyles:any={width:'100%',height:'100%'};
        let afterStyles:any={width:'100%',height:'100%'};
        let additionalStyles:any={};
        let isImmediate:boolean=false;
        let contentScroll='auto';
        switch (this.state.Status) {
            case "resting":
                beforeStyles={};
                afterStyles.height='auto';
                isImmediate=true;
                break;
            case "switching":
                contentScroll='hidden';
                isImmediate=true;
                afterStyles.height=this.state.SelectedItem.Container?this.state.SelectedItem.Container.offsetHeight+1:'auto';
                break;
            case "showing":

                if(this.state.NextItem.Container!=null) {

                    if (this.Content != null && this.ListContainer != null)
                            contentScroll = 'hidden';
                    afterStyles.height=this.state.NextItem.Container.offsetHeight+1;
                }else
                    afterStyles.height='auto';
                break;

        }

        let selectedItem=this.state.SelectedItem;
        if(this.state.Status=="showing")
            selectedItem=this.state.NextItem;


        return (
            <div ref={node=>this.Content=node} className={'rnTabs '+this.props.className} style={this.props.styles}>
                <ul style={{margin:0,padding:0,...this.props.TabStyles}} ref={node=>this.ListContainer=node}>
                {this.state.Items.map((x,index)=> (
                        <li key={index} className={x.Item.props.Id+ ' rnTabItem '+(selectedItem==x?'rnActive':'')} onClick={()=>this.SwitchVisibleItem(x)} >
                            <React.Fragment>
                                {x.Item.props.Icon!=null&&
                                <div  style={{display:'inline-block', marginRight:2}}>{x.Item.props.Icon}</div>}
                                {x.Item.props.Title}
                            </React.Fragment>
                        </li>
                    ))}
                </ul>

                <Spring onRest={e=>this.OnRest()} ref={node=>this.spring=node}  config={{precision:.09}}   immediate={isImmediate} from={beforeStyles} to={afterStyles} onFrame={e=>{this.OnFrame(e.height,afterStyles.height);}} >
                    {



                        ((styles,ref)=>{
                        return (


                        <div ref={node=>ref(node)} className={"rnTabContent"} style={{maxHeight:this.props.OccupyAvailableSpace==false||this.ListContainer==null?"none":`calc(100% - ${this.ListContainer.getBoundingClientRect().height}px)`, ...styles,position:'relative',borderTopLeftRadius:this.state.Items[0]==this.state.SelectedItem?0:5,overflowY:contentScroll}}>
                            {this.state.Items.map((x,index)=>{
                                let additionalStyles:any={};
                                let afterStyles:any={opacity:0};
                                if(this.state.SelectedItem==x)
                                {
                                    additionalStyles.display='block';
                                    afterStyles.opacity=1;
                                    if(this.state.Status=="showing") {
                                        additionalStyles.position = 'absolute';
                                        afterStyles.opacity=0;
                                    }
                                }
                                if(this.state.NextItem==x)
                                {
                                    additionalStyles.display='block';
                                    additionalStyles.position='absolute';
                                    additionalStyles.top=0;
                                    additionalStyles.left=0;
                                    additionalStyles.height='auto';

                                    if(this.state.Status=="showing") {
                                        afterStyles.opacity=1;
                                    }
                                }
                                return (
                                    <Spring ref={node=>this.spring2=node}   config={{precision:.09}}  key={index} immediate={this.state.Status!="showing"}  from={{width:'100%'}} to={afterStyles}>
                                        {
                                            ((styles2,ref)=>{return (
                                            <div style={{...styles2,padding:10,...x.Item.props.style, width:'100%',height:'100%',display:'none',...additionalStyles}} ref={node=>{ref(node);x.Container=node}}>
                                                {x.Item.props.children}
                                            </div>
                                        )})as any

                                        }

                                    </Spring>
                                )
                            })}
                        </div>
                    )})as any



                    }
                </Spring>


            </div>
        )
    }

    private SwitchVisibleItem(x: ItemData) {
        if(this.props.TabToOpen)
            this.props.TabToOpenChanged(x.Item.props.Id);


    }



    private TabsToOpenChanged(newValue:any){
        let item=this.state.Items.find(x=>x.Item.props.Id==newValue);
        if(!item)
            item=this.state.Items.length>0?this.state.Items[0]:null

        this.setState({Status:"switching",NextItem:item},()=>{this.setState({Status:"showing"})});
    }

    private CalculateOverflowToUse() {
        if(this.state.Status=="switching")
            return 'hidden';
        if(this.state.Status=='showing'&&this.props.disableScrollYOnAnimation)
        {
            return 'showing';
        }
        return 'auto';
    }

    private OnFrame(newHeight: any, objetiveHeight: any) {

        newHeight=Math.round(newHeight);
        objetiveHeight=Math.round(objetiveHeight);
        if(newHeight<objetiveHeight) {
            if (newHeight >= objetiveHeight - 5) {
                this.spring.stop();

            }
        }else
            if(newHeight<=objetiveHeight+5) {
                this.spring.stop();

            }




    }
}
/* /*<SwitchContainer className={'rnTabContent'} style={{borderTopLeftRadius:this.state.Items[0]==this.state.SelectedItem?0:5}} config={{restDisplacementThreshold:5,restSpeedThreshold:10}}>
                    {this.state.SelectedItem?this.state.SelectedItem.props.children:null}
                </SwitchContainer>*/

interface ItemData{
    Item:Item;
    Container:HTMLDivElement
}

//#region ----------------------------------------------------"State and props"------------------------------------------------------------------------------------
interface TabsProps {
    styles?:CSSProperties;
    disableScrollYOnAnimation?:boolean;
    TabToOpen:string;
    ContentHeight:string;
    ContentStyles:CSSProperties;
    OccupyAvailableSpace:boolean;
    TabToOpenChanged:(id)=>void;
    className:string;
    TabStyles:CSSProperties;

}

interface TabsState {
    Items:ItemData[];
    SelectedItem:ItemData;
    NextItem:ItemData;
    Status:'switching'|'resting'|'showing'


}

//#endregion "My Region"